import styled from 'styled-components';

export const OnboardingTutorialStyled = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--color-surface);
`;

export const OnboardingTutorialContentButtonStyled = styled.div`
    width: 100%;
    height: 48px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
`;
